import { useState } from "react";
import { useQueryClient } from "@tanstack/react-query";
// Hooks
import { useCheckAPI } from "../../hooks/useCheckAPI";
// State Import
import { useUserBranches } from "../../state/userBranchListState";
// MUI
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";

export const ReturnTableFilterBar = ({ returnsFilter, setReturnsFilter }) => {
  const [currentSearchValue, setCurrentSearchValue] = useState(
    returnsFilter.search || "",
  );
  const [userBranches, setUserBranches] = useState([]);
  const queryClient = useQueryClient();
  const { isSuccess, data } = useUserBranches();

  // Success Function
  const successFunc = () => setUserBranches(data.data.data.data.list.branch);

  // Error Function
  const errorFunc = () =>
    console.warn(`Error: ${data.status}: ${data.statusText}`);

  // Hook to check the BC API for errors
  useCheckAPI(isSuccess, data, data?.status, successFunc, errorFunc);

  const handleSearchChange = (newValue) => {
    setCurrentSearchValue(newValue.target.value);
  };

  const handleSearchSumbit = (e) => {
    e.preventDefault();
    setReturnsFilter((prevState) => ({
      ...prevState,
      search: currentSearchValue,
    }));
    invalidateQuery();
  };

  const handleSearchClear = () => {
    setCurrentSearchValue("");
    setReturnsFilter((prevState) => ({
      ...prevState,
      search: "",
    }));
    invalidateQuery();
  };

  const handleBranchFilterChange = (e) => {
    setReturnsFilter((prevState) => ({
      ...prevState,
      branchFilter: e.target.value,
    }));
    invalidateQuery();
  };

  const handleMyBranchesFilterChange = (e) => {
    setReturnsFilter((prevState) => ({
      ...prevState,
      myBranchesFilter: e.target.value,
    }));
    invalidateQuery();
  };

  const invalidateQuery = () => {
    queryClient.invalidateQueries({
      queryKey: ["completedReturnOrderList"],
      exact: true,
    });
  };

  return (
    <Stack direction={{ xs: "column", md: "row" }} spacing={{ xs: 2, md: 1 }}>
      <Box component="form" onSubmit={handleSearchSumbit} sx={{ flexGrow: 1 }}>
        <TextField
          onChange={handleSearchChange}
          value={currentSearchValue}
          label="Search.."
          id="return-table-search"
          name="Search"
          variant="outlined"
          size="small"
          fullWidth
          slotProps={{
            input: {
              endAdornment: (
                <>
                  <InputAdornment
                    position="end"
                    sx={{
                      visibility: currentSearchValue ? "visible" : "hidden",
                    }}
                  >
                    <IconButton onClick={handleSearchClear} color="error">
                      <ClearIcon />
                    </IconButton>
                  </InputAdornment>
                  <InputAdornment position="end">
                    <IconButton type="submit">
                      <SearchIcon />
                    </IconButton>
                  </InputAdornment>
                </>
              ),
            },
          }}
        />
      </Box>
      <Stack direction="row" spacing={1} sx={{ minWidth: { md: 400 } }}>
        {/* {!myBranchesOnly && ( */}
        <TextField
          onChange={handleBranchFilterChange}
          id="branch-filter"
          select
          label="Branch Filter"
          value={returnsFilter.branchFilter}
          size="small"
          fullWidth
          // disabled={myBranchesOnly}
        >
          <MenuItem value={"Mine"}>Create by Me</MenuItem>
          <MenuItem value={"All"}>Orders for My Branches</MenuItem>
        </TextField>
        {/* )} */}
        <TextField
          onChange={handleMyBranchesFilterChange}
          id="my-branches-filter"
          select
          label="My Branches"
          value={returnsFilter.myBranchesFilter}
          disabled={returnsFilter.branchFilter === "All" ? false : true}
          size="small"
          fullWidth
        >
          <MenuItem value={"All"}>All</MenuItem>
          {userBranches?.map((branch) => (
            <MenuItem key={branch.no} value={branch.no}>
              {branch.name}
            </MenuItem>
          ))}
        </TextField>
      </Stack>
    </Stack>
  );
};
